import "core-js/modules/es.array.reverse.js";
var _class, _SdmxJsonDataflowStratum;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { computed, makeObservable } from "mobx";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import { networkRequestError } from "../../../Core/TerriaError";
import { MetadataUrlTraits, ShortReportTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import { FeatureInfoTemplateTraits } from "../../../Traits/TraitsClasses/FeatureInfoTraits";
import LegendTraits from "../../../Traits/TraitsClasses/LegendTraits";
import SdmxCatalogItemTraits from "../../../Traits/TraitsClasses/SdmxCatalogItemTraits";
import { ModelOverrideTraits } from "../../../Traits/TraitsClasses/SdmxCommonTraits";
import TableChartStyleTraits, { TableChartLineStyleTraits } from "../../../Traits/TraitsClasses/Table/ChartStyleTraits";
import TableColorStyleTraits from "../../../Traits/TraitsClasses/Table/ColorStyleTraits";
import TableColumnTraits, { ColumnTransformationTraits } from "../../../Traits/TraitsClasses/Table/ColumnTraits";
import TableStyleTraits from "../../../Traits/TraitsClasses/Table/StyleTraits";
import TableTimeStyleTraits from "../../../Traits/TraitsClasses/Table/TimeStyleTraits";
import createCombinedModel from "../../Definition/createCombinedModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import { filterEnums } from "../../SelectableDimensions/SelectableDimensions";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import { loadSdmxJsonStructure, parseSdmxUrn } from "./SdmxJsonServerStratum";
export let SdmxJsonDataflowStratum = (_class = (_SdmxJsonDataflowStratum = class SdmxJsonDataflowStratum extends LoadableStratum(SdmxCatalogItemTraits) {
  duplicateLoadableStratum(model) {
    return new SdmxJsonDataflowStratum(model, this.sdmxJsonDataflow);
  }

  /**
   * Load SDMX-JSON dataflow - will also load references (dataStructure, codelists, conceptSchemes, contentConstraints)
   */
  static async load(catalogItem) {
    // Load dataflow (+ all related references)
    const dataflowStructure = await loadSdmxJsonStructure(proxyCatalogItemUrl(catalogItem, "".concat(catalogItem.baseUrl, "/dataflow/").concat(catalogItem.agencyId, "/").concat(catalogItem.dataflowId, "?references=all")), false);

    // Check response
    if (!isDefined(dataflowStructure.data)) {
      throw networkRequestError({
        title: i18next.t("models.sdmxJsonDataflowStratum.loadDataErrorTitle"),
        message: i18next.t("models.sdmxJsonDataflowStratum.loadDataErrorMessage.invalidResponse")
      });
    }
    if (!Array.isArray(dataflowStructure.data.dataflows) || dataflowStructure.data.dataflows.length === 0) {
      throw networkRequestError({
        title: i18next.t("models.sdmxJsonDataflowStratum.loadDataErrorTitle"),
        message: i18next.t("models.sdmxJsonDataflowStratum.loadDataErrorMessage.noDataflow", this)
      });
    }
    if (!Array.isArray(dataflowStructure.data.dataStructures) || dataflowStructure.data.dataStructures.length === 0) {
      throw networkRequestError({
        title: i18next.t("models.sdmxJsonDataflowStratum.loadDataErrorTitle"),
        message: i18next.t("models.sdmxJsonDataflowStratum.loadDataErrorMessage.noDatastructure", this)
      });
    }
    return new SdmxJsonDataflowStratum(catalogItem, {
      dataflow: dataflowStructure.data.dataflows[0],
      dataStructure: dataflowStructure.data.dataStructures[0],
      codelists: dataflowStructure.data.codelists,
      conceptSchemes: dataflowStructure.data.conceptSchemes,
      contentConstraints: dataflowStructure.data.contentConstraints
    });
  }
  constructor(catalogItem, sdmxJsonDataflow) {
    super();
    this.catalogItem = catalogItem;
    this.sdmxJsonDataflow = sdmxJsonDataflow;
    makeObservable(this);
  }
  get description() {
    return this.sdmxJsonDataflow.dataflow.description;
  }

  /** Transform dataflow annotations with type "EXT_RESOURCE"
   * These can be of format:
   * - ${title}|${url}|${imageUrl}
   * - EG "Metadata|http://purl.org/spc/digilib/doc/7thdz|https://sdd.spc.int/themes/custom/sdd/images/icons/metadata.png"
   */
  get metadataUrls() {
    var _this$sdmxJsonDataflo, _this$sdmxJsonDataflo2;
    return filterOutUndefined((_this$sdmxJsonDataflo = (_this$sdmxJsonDataflo2 = this.sdmxJsonDataflow) === null || _this$sdmxJsonDataflo2 === void 0 || (_this$sdmxJsonDataflo2 = _this$sdmxJsonDataflo2.dataflow.annotations) === null || _this$sdmxJsonDataflo2 === void 0 ? void 0 : _this$sdmxJsonDataflo2.filter(a => a.type === "EXT_RESOURCE" && a.text).map(annotation => {
      var _annotation$texts$i, _annotation$texts;
      const text = (_annotation$texts$i = (_annotation$texts = annotation.texts) === null || _annotation$texts === void 0 ? void 0 : _annotation$texts[i18next.language]) !== null && _annotation$texts$i !== void 0 ? _annotation$texts$i : annotation.text;
      const title = text.includes("|") ? text.split("|")[0] : undefined;
      const url = text.includes("|") ? text.split("|")[1] : text;
      return createStratumInstance(MetadataUrlTraits, {
        title,
        url
      });
    })) !== null && _this$sdmxJsonDataflo !== void 0 ? _this$sdmxJsonDataflo : []);
  }
  get sdmxAttributes() {
    var _this$sdmxJsonDataflo3, _this$sdmxJsonDataflo4;
    return (_this$sdmxJsonDataflo3 = (_this$sdmxJsonDataflo4 = this.sdmxJsonDataflow.dataStructure.dataStructureComponents) === null || _this$sdmxJsonDataflo4 === void 0 || (_this$sdmxJsonDataflo4 = _this$sdmxJsonDataflo4.attributeList) === null || _this$sdmxJsonDataflo4 === void 0 ? void 0 : _this$sdmxJsonDataflo4.attributes) !== null && _this$sdmxJsonDataflo3 !== void 0 ? _this$sdmxJsonDataflo3 : [];
  }
  get sdmxDimensions() {
    var _this$sdmxJsonDataflo5, _this$sdmxJsonDataflo6;
    return (_this$sdmxJsonDataflo5 = (_this$sdmxJsonDataflo6 = this.sdmxJsonDataflow.dataStructure.dataStructureComponents) === null || _this$sdmxJsonDataflo6 === void 0 || (_this$sdmxJsonDataflo6 = _this$sdmxJsonDataflo6.dimensionList) === null || _this$sdmxJsonDataflo6 === void 0 ? void 0 : _this$sdmxJsonDataflo6.dimensions) !== null && _this$sdmxJsonDataflo5 !== void 0 ? _this$sdmxJsonDataflo5 : [];
  }
  get sdmxTimeDimensions() {
    var _this$sdmxJsonDataflo7, _this$sdmxJsonDataflo8;
    return (_this$sdmxJsonDataflo7 = (_this$sdmxJsonDataflo8 = this.sdmxJsonDataflow.dataStructure.dataStructureComponents) === null || _this$sdmxJsonDataflo8 === void 0 ? void 0 : _this$sdmxJsonDataflo8.dimensionList.timeDimensions) !== null && _this$sdmxJsonDataflo7 !== void 0 ? _this$sdmxJsonDataflo7 : [];
  }
  get sdmxPrimaryMeasure() {
    var _this$sdmxJsonDataflo9;
    return (_this$sdmxJsonDataflo9 = this.sdmxJsonDataflow.dataStructure.dataStructureComponents) === null || _this$sdmxJsonDataflo9 === void 0 ? void 0 : _this$sdmxJsonDataflo9.measureList.primaryMeasure;
  }

  /**
   * If we get a dataflow with a single value (and not region-mapped), show the exact value in a short report
   */
  get shortReportSections() {
    if (this.catalogItem.mapItems.length !== 0 || this.catalogItem.isLoading) return;
    const primaryCol = this.catalogItem.tableColumns.find(col => {
      var _this$primaryMeasureC;
      return col.name === ((_this$primaryMeasureC = this.primaryMeasureColumn) === null || _this$primaryMeasureC === void 0 ? void 0 : _this$primaryMeasureC.name);
    });
    if ((primaryCol === null || primaryCol === void 0 ? void 0 : primaryCol.valuesAsNumbers.values.length) === 1 && typeof (primaryCol === null || primaryCol === void 0 ? void 0 : primaryCol.valuesAsNumbers.values[0]) === "number") {
      return [createStratumInstance(ShortReportTraits, {
        name: this.chartTitle,
        content: primaryCol === null || primaryCol === void 0 ? void 0 : primaryCol.valuesAsNumbers.values[0].toLocaleString(undefined, primaryCol.traits.format)
      })];
    }
  }

  // ------------- START SDMX TRAITS STRATUM -------------

  /** Merge codelist and concept model overrides (codelist takes priority) */
  getMergedModelOverride(dim) {
    const conceptOverride = this.catalogItem.modelOverrides.find(concept => concept.id === dim.conceptIdentity);
    const codelistOverride = this.catalogItem.modelOverrides.find(codelist => {
      var _dim$localRepresentat;
      return codelist.id === ((_dim$localRepresentat = dim.localRepresentation) === null || _dim$localRepresentat === void 0 ? void 0 : _dim$localRepresentat.enumeration);
    });
    let modelOverride = conceptOverride;
    if (!modelOverride) {
      modelOverride = codelistOverride;

      // If there is a codelist and concept override, merge them
    } else if (codelistOverride) {
      modelOverride = createCombinedModel(codelistOverride, modelOverride);
    }
    return modelOverride;
  }
  /**
   * This maps SDMX-JSON dataflow structure to `SdmxDimensionTraits` (which gets turned into `SelectableDimensions`) - it uses:
   * - Data structure's dimensions (filtered to only include "enumerated" dimensions)
   * - Content constraints to find dimension options
   * - Codelists to add human readable labels to dimension options
   *
   * It will also apply ModelOverrides - which are used to override dimension values based on concept/codelist ID.
   * - @see ModelOverrideTraits
   */
  get dimensions() {
    var _this$sdmxJsonDataflo0;
    // Constraint contains allowed dimension values for a given dataflow
    // Get 'actual' constraints (rather than 'allowed' constraints)
    const constraints = (_this$sdmxJsonDataflo0 = this.sdmxJsonDataflow.contentConstraints) === null || _this$sdmxJsonDataflo0 === void 0 ? void 0 : _this$sdmxJsonDataflo0.filter(c => c.type === "Actual");
    return this.sdmxDimensions
    // Filter normal enum dimensions
    .filter(dim => {
      var _dim$localRepresentat2;
      return dim.id && dim.type === "Dimension" && ((_dim$localRepresentat2 = dim.localRepresentation) === null || _dim$localRepresentat2 === void 0 ? void 0 : _dim$localRepresentat2.enumeration);
    }).map(dim => {
      var _dim$localRepresentat3, _ref, _codelist$codes, _options$, _modelOverride$name;
      const modelOverride = this.getMergedModelOverride(dim);

      // Concept maps dimension's ID to a human-readable name
      const concept = this.getConceptByUrn(dim.conceptIdentity);

      // Codelist maps dimension enum values to human-readable labels
      const codelist = this.getCodelistByUrn((_dim$localRepresentat3 = dim.localRepresentation) === null || _dim$localRepresentat3 === void 0 ? void 0 : _dim$localRepresentat3.enumeration);

      // Get allowed options from constraints.cubeRegions (there may be multiple - take union of all values)
      const allowedOptionIds = Array.isArray(constraints) ? constraints.reduce((keys, constraint) => {
        var _constraint$cubeRegio;
        (_constraint$cubeRegio = constraint.cubeRegions) === null || _constraint$cubeRegio === void 0 || _constraint$cubeRegio.forEach(cubeRegion => {
          var _cubeRegion$keyValues;
          return (_cubeRegion$keyValues = cubeRegion.keyValues) === null || _cubeRegion$keyValues === void 0 || (_cubeRegion$keyValues = _cubeRegion$keyValues.filter(kv => kv.id === dim.id)) === null || _cubeRegion$keyValues === void 0 ? void 0 : _cubeRegion$keyValues.forEach(regionKey => {
            var _regionKey$values;
            return (_regionKey$values = regionKey.values) === null || _regionKey$values === void 0 ? void 0 : _regionKey$values.forEach(value => keys.add(value));
          });
        });
        return keys;
      }, new Set()) : new Set();

      // Get codes by merging allowedOptionIds with codelist
      const filteredCodesList = (_ref = allowedOptionIds.size > 0 ? codelist === null || codelist === void 0 || (_codelist$codes = codelist.codes) === null || _codelist$codes === void 0 ? void 0 : _codelist$codes.filter(code => allowedOptionIds.has(code.id)) : // If no allowedOptions were found -> return all codes
      codelist === null || codelist === void 0 ? void 0 : codelist.codes) !== null && _ref !== void 0 ? _ref : [];

      // Create options object
      // If modelOverride `options` has been defined -> use it
      // Other wise use filteredCodesList
      const overrideOptions = modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.options;
      const options = isDefined(overrideOptions) && overrideOptions.length > 0 ? overrideOptions.map(option => {
        return {
          id: option.id,
          name: option.name,
          value: undefined
        };
      }) : filteredCodesList.map(code => {
        return {
          id: code.id,
          name: code.name,
          value: undefined
        };
      });

      // Use first option as default if no other default is provided
      let selectedId = modelOverride !== null && modelOverride !== void 0 && modelOverride.allowUndefined ? undefined : (_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.id;

      // Override selectedId if it a valid option
      const selectedIdOverride = modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.selectedId;
      if (isDefined(selectedIdOverride) && options.find(option => option.id === selectedIdOverride)) {
        selectedId = selectedIdOverride;
      }
      return {
        id: dim.id,
        name: (_modelOverride$name = modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.name) !== null && _modelOverride$name !== void 0 ? _modelOverride$name : concept === null || concept === void 0 ? void 0 : concept.name,
        options: options,
        position: dim.position,
        disable: modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.disable,
        allowUndefined: modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.allowUndefined,
        selectedId: selectedId
      };
    }).filter(isDefined);
  }

  /**
   * Adds SDMX Common concepts as model overrides:
   * - `UNIT_MEASURE` (see `this.unitMeasure`)
   * - `UNIT_MULT` (see `this.primaryMeasureColumn`)
   * - `FREQ` (see `this.unitMeasure`)
   */
  get modelOverrides() {
    return filterOutUndefined(
    // Map through all dimensions and attributes to find ones which use common concepts
    [...this.sdmxDimensions, ...this.sdmxAttributes].map(dimAttr => {
      var _conceptUrn$descendan, _conceptUrn$descendan2, _conceptUrn$descendan3;
      const conceptUrn = parseSdmxUrn(dimAttr.conceptIdentity);
      // Add UNIT_MEASURE common concept override for unit-measure
      if ((conceptUrn === null || conceptUrn === void 0 || (_conceptUrn$descendan = conceptUrn.descendantIds) === null || _conceptUrn$descendan === void 0 ? void 0 : _conceptUrn$descendan[0]) === "UNIT_MEASURE") {
        return createStratumInstance(ModelOverrideTraits, {
          id: dimAttr.conceptIdentity,
          type: "unit-measure"
        });
        // Add UNIT_MULT common concept override for unit-multiplier
      } else if ((conceptUrn === null || conceptUrn === void 0 || (_conceptUrn$descendan2 = conceptUrn.descendantIds) === null || _conceptUrn$descendan2 === void 0 ? void 0 : _conceptUrn$descendan2[0]) === "UNIT_MULT") {
        return createStratumInstance(ModelOverrideTraits, {
          id: dimAttr.conceptIdentity,
          type: "unit-multiplier"
        });
        // Add FREQUENCY common concept override for frequency
      } else if ((conceptUrn === null || conceptUrn === void 0 || (_conceptUrn$descendan3 = conceptUrn.descendantIds) === null || _conceptUrn$descendan3 === void 0 ? void 0 : _conceptUrn$descendan3[0]) === "FREQ") {
        return createStratumInstance(ModelOverrideTraits, {
          id: dimAttr.conceptIdentity,
          type: "frequency"
        });
      }
    }));
  }

  /**
   * Get unitMeasure string using modelOverrides.
   * - Search for columns linked to dimensions/attributes which have modelOverrides of type "unit-measure"
   * - We will only use a column if it has a single unique value - as this unitMeasure it used effectively as "units" for the dataset
   * - Also search for dimensions which have modelOverrides of type "frequency".
   * - These will be used to add the frequency to the end of the unitMeasure string
   * For example: "Value (Yearly)" or "AUD (Quarterly)"
   *
   */
  get unitMeasure() {
    var _this$catalogItem$mod, _frequencyDim$options, _frequencyDim$options2;
    // Find tableColumns which have corresponding modelOverride with type `unit-measure`
    // We will only use columns if they have a single unique value
    const unitMeasure = filterOutUndefined((_this$catalogItem$mod = this.catalogItem.modelOverrides) === null || _this$catalogItem$mod === void 0 ? void 0 : _this$catalogItem$mod.filter(override => override.type === "unit-measure" && override.id).map(override => {
      var _this$getAttributionW;
      // Find dimension/attribute id with concept or codelist override
      const dimOrAttr = (_this$getAttributionW = this.getAttributionWithConceptOrCodelist(override.id)) !== null && _this$getAttributionW !== void 0 ? _this$getAttributionW : this.getDimensionWithConceptOrCodelist(override.id);
      const column = this.catalogItem.findColumnByName(dimOrAttr === null || dimOrAttr === void 0 ? void 0 : dimOrAttr.id);
      if ((column === null || column === void 0 ? void 0 : column.uniqueValues.values.length) === 1) {
        var _dimOrAttr$localRepre, _codelist$codes$find$, _codelist$codes2;
        // If this column has a codelist, use it to format the value
        const codelist = this.getCodelistByUrn(dimOrAttr === null || dimOrAttr === void 0 || (_dimOrAttr$localRepre = dimOrAttr.localRepresentation) === null || _dimOrAttr$localRepre === void 0 ? void 0 : _dimOrAttr$localRepre.enumeration);
        const value = column === null || column === void 0 ? void 0 : column.uniqueValues.values[0];
        return (_codelist$codes$find$ = codelist === null || codelist === void 0 || (_codelist$codes2 = codelist.codes) === null || _codelist$codes2 === void 0 || (_codelist$codes2 = _codelist$codes2.find(c => c.id === value)) === null || _codelist$codes2 === void 0 ? void 0 : _codelist$codes2.name) !== null && _codelist$codes$find$ !== void 0 ? _codelist$codes$find$ : value;
      }
    })).join(", ");

    // Find frequency from dimensions with modelOverrides of type "frequency".
    const frequencyDim = this.getDimensionsWithOverrideType("frequency").find(dim => isDefined(dim.selectedId));

    // Try to get option label if it exists
    const frequency = (_frequencyDim$options = frequencyDim === null || frequencyDim === void 0 || (_frequencyDim$options2 = frequencyDim.options.find(o => o.id === frequencyDim.selectedId)) === null || _frequencyDim$options2 === void 0 ? void 0 : _frequencyDim$options2.name) !== null && _frequencyDim$options !== void 0 ? _frequencyDim$options : frequencyDim === null || frequencyDim === void 0 ? void 0 : frequencyDim.id;
    return "".concat(unitMeasure || i18next.t("models.sdmxJsonDataflowStratum.defaultUnitMeasure")).concat(frequency ? " (".concat(frequency, ")") : "");
  }

  // ------------- START TABLE TRAITS STRATUM -------------

  /**
   * Add TableColumnTraits for primary measure column - this column contains observational values to be visualised on chart or map:
   * - `name` to dimension id
   * - `title` to concept name
   * - `transformation` if unit multiplier attribute has been found (which will apply `x*(10^unitMultiplier)` to all observation values)
   */
  get primaryMeasureColumn() {
    var _this$sdmxPrimaryMeas, _this$catalogItem$mod2, _this$sdmxPrimaryMeas2;
    if (!this.sdmxPrimaryMeasure) return;
    const primaryMeasureConcept = this.getConceptByUrn((_this$sdmxPrimaryMeas = this.sdmxPrimaryMeasure) === null || _this$sdmxPrimaryMeas === void 0 ? void 0 : _this$sdmxPrimaryMeas.conceptIdentity);

    // Find unit multiplier columns by searching for attributes/dimensions which have modelOverrides of type "unit-multiplier".
    // Use the first column found
    const unitMultiplier = filterOutUndefined((_this$catalogItem$mod2 = this.catalogItem.modelOverrides) === null || _this$catalogItem$mod2 === void 0 ? void 0 : _this$catalogItem$mod2.filter(override => override.type === "unit-multiplier" && override.id).map(override => {
      var _this$getAttributionW2;
      // Find dimension/attribute id with concept or codelist
      const dimOrAttr = (_this$getAttributionW2 = this.getAttributionWithConceptOrCodelist(override.id)) !== null && _this$getAttributionW2 !== void 0 ? _this$getAttributionW2 : this.getDimensionWithConceptOrCodelist(override.id);
      return dimOrAttr === null || dimOrAttr === void 0 ? void 0 : dimOrAttr.id;
    }))[0];
    return createStratumInstance(TableColumnTraits, {
      name: (_this$sdmxPrimaryMeas2 = this.sdmxPrimaryMeasure) === null || _this$sdmxPrimaryMeas2 === void 0 ? void 0 : _this$sdmxPrimaryMeas2.id,
      title: primaryMeasureConcept === null || primaryMeasureConcept === void 0 ? void 0 : primaryMeasureConcept.name,
      type: "scalar",
      // If a unitMultiplier was found, we add `x*(10^unitMultiplier)` transformation
      transformation: unitMultiplier ? createStratumInstance(ColumnTransformationTraits, {
        expression: "x*(10^".concat(unitMultiplier, ")"),
        dependencies: [unitMultiplier]
      }) : undefined
    });
  }

  /**
   * Add TableColumnTraits for dimensions
   * The main purpose of this is to try to find the region type for columns.
   * It also adds:
   * - `name` as dimension id
   * - `title` as concept name (more human-readable than dimension id)
   * - `type` to `region` if a valid region-type is found, or `hidden` if the dimension is disabled
   */

  get dimensionColumns() {
    var _this$sdmxDimensions$;
    // Get columns for all dimensions (excluding time dimensions)
    return (_this$sdmxDimensions$ = this.sdmxDimensions.filter(dim => isDefined(dim.id)).map(dim => {
      var _this$dimensions, _dim$localRepresentat4, _this$catalogItem$mat, _ref2, _ref3, _ref4, _this$catalogItem$mat4, _this$catalogItem$mat5, _this$catalogItem$mat6, _this$catalogItem$mat7, _this$catalogItem$mat8, _this$catalogItem$mat9;
      // Hide dimension columns if they are disabled
      if ((_this$dimensions = this.dimensions) !== null && _this$dimensions !== void 0 && (_this$dimensions = _this$dimensions.find(d => d.id === dim.id)) !== null && _this$dimensions !== void 0 && _this$dimensions.disable) {
        return createStratumInstance(TableColumnTraits, {
          name: dim.id,
          type: "hidden"
        });
      }

      // Get concept for the current dimension
      const concept = this.getConceptByUrn(dim.conceptIdentity);
      // Get codelist for current dimension
      const codelist = this.getCodelistByUrn((_dim$localRepresentat4 = dim.localRepresentation) === null || _dim$localRepresentat4 === void 0 ? void 0 : _dim$localRepresentat4.enumeration);
      const modelOverride = this.getMergedModelOverride(dim);

      // Try to find region type
      let regionType;

      // Are any regionTypes present in modelOverride
      regionType = (_this$catalogItem$mat = this.catalogItem.matchRegionProvider(modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.regionType)) === null || _this$catalogItem$mat === void 0 ? void 0 : _this$catalogItem$mat.regionType;

      // Next try fetching region type from another dimension (only if this modelOverride type 'region')
      // It will look through dimensions which have modelOverrides of type `region-type` and have a selectedId, if one is found - it will be used as the regionType of this column
      // Note this will override previous regionType
      if ((modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.type) === "region") {
        var _this$catalogItem$mat2, _this$catalogItem$mat3, _this$getDimensionsWi;
        // Use selectedId of first dimension with one
        regionType = (_this$catalogItem$mat2 = (_this$catalogItem$mat3 = this.catalogItem.matchRegionProvider((_this$getDimensionsWi = this.getDimensionsWithOverrideType("region-type").find(d => isDefined(d.selectedId))) === null || _this$getDimensionsWi === void 0 ? void 0 : _this$getDimensionsWi.selectedId)) === null || _this$catalogItem$mat3 === void 0 ? void 0 : _this$catalogItem$mat3.regionType) !== null && _this$catalogItem$mat2 !== void 0 ? _this$catalogItem$mat2 : regionType;
      }

      // Try to find valid region type from:
      // - dimension ID
      // - codelist name
      // - codelist ID
      // - concept name?
      // - concept id (the string, not the full URN)

      if (!isDefined(regionType)) regionType = (_ref2 = (_ref3 = (_ref4 = (_this$catalogItem$mat4 = (_this$catalogItem$mat5 = this.catalogItem.matchRegionProvider(dim.id)) === null || _this$catalogItem$mat5 === void 0 ? void 0 : _this$catalogItem$mat5.regionType) !== null && _this$catalogItem$mat4 !== void 0 ? _this$catalogItem$mat4 : (_this$catalogItem$mat6 = this.catalogItem.matchRegionProvider(codelist === null || codelist === void 0 ? void 0 : codelist.name)) === null || _this$catalogItem$mat6 === void 0 ? void 0 : _this$catalogItem$mat6.regionType) !== null && _ref4 !== void 0 ? _ref4 : (_this$catalogItem$mat7 = this.catalogItem.matchRegionProvider(codelist === null || codelist === void 0 ? void 0 : codelist.id)) === null || _this$catalogItem$mat7 === void 0 ? void 0 : _this$catalogItem$mat7.regionType) !== null && _ref3 !== void 0 ? _ref3 : (_this$catalogItem$mat8 = this.catalogItem.matchRegionProvider(concept === null || concept === void 0 ? void 0 : concept.name)) === null || _this$catalogItem$mat8 === void 0 ? void 0 : _this$catalogItem$mat8.regionType) !== null && _ref2 !== void 0 ? _ref2 : (_this$catalogItem$mat9 = this.catalogItem.matchRegionProvider(concept === null || concept === void 0 ? void 0 : concept.id)) === null || _this$catalogItem$mat9 === void 0 ? void 0 : _this$catalogItem$mat9.regionType;

      // Apply regionTypeReplacements (which can replace regionType with a different regionType - using [{find:string, replace:string}] pattern)
      if ((modelOverride === null || modelOverride === void 0 ? void 0 : modelOverride.type) === "region") {
        var _modelOverride$region;
        const replacement = modelOverride === null || modelOverride === void 0 || (_modelOverride$region = modelOverride.regionTypeReplacements) === null || _modelOverride$region === void 0 || (_modelOverride$region = _modelOverride$region.find(r => r.find === regionType)) === null || _modelOverride$region === void 0 ? void 0 : _modelOverride$region.replace;
        if (isDefined(replacement)) {
          regionType = replacement;
        }
      }
      return createStratumInstance(TableColumnTraits, {
        name: dim.id,
        title: concept === null || concept === void 0 ? void 0 : concept.name,
        // We set columnType to hidden for all columns except for region columns - as we are never interested in visualising them
        // For "time" columns see `get timeColumns()`
        // For primary measure ("scalar") column - see `get primaryMeasureColumn()`
        type: isDefined(regionType) ? "region" : "hidden",
        regionType
      });
    })) !== null && _this$sdmxDimensions$ !== void 0 ? _this$sdmxDimensions$ : [];
  }

  /**
   * Add traits for time columns:
   * - `name` to dimension id
   * - `type = time`
   * - `title` to concept name (if it exists)
   */
  get timeColumns() {
    var _this$sdmxTimeDimensi;
    return (_this$sdmxTimeDimensi = this.sdmxTimeDimensions.map(dim => {
      var _concept$name;
      const concept = this.getConceptByUrn(dim.conceptIdentity);
      return createStratumInstance(TableColumnTraits, {
        name: dim.id,
        title: (_concept$name = concept === null || concept === void 0 ? void 0 : concept.name) !== null && _concept$name !== void 0 ? _concept$name : dim.id,
        type: "time"
      });
    })) !== null && _this$sdmxTimeDimensi !== void 0 ? _this$sdmxTimeDimensi : [];
  }

  /**
   * Add traits for attribute columns - all attribute columns are hidden, they are used to describe the primary measure (in feature info, unit measure, unit multiplier...):
   * - `name` to attribute id
   * - `type = hidden`
   */
  get attributeColumns() {
    var _this$sdmxAttributes$;
    return (_this$sdmxAttributes$ = this.sdmxAttributes.map(attr => {
      return createStratumInstance(TableColumnTraits, {
        name: attr.id,
        type: "hidden"
      });
    })) !== null && _this$sdmxAttributes$ !== void 0 ? _this$sdmxAttributes$ : [];
  }

  /**
   * Munge all columns together
   */
  get columns() {
    return filterOutUndefined([this.primaryMeasureColumn, ...this.dimensionColumns, ...this.timeColumns, ...this.attributeColumns]);
  }

  /** Get region TableColumn by searching catalogItem.tableColumns for region dimension
   * NOTE: this is searching through catalogItem.tableColumns to find the completely resolved regionColumn
   * This can only be used in computed/fns outside of ColumnTraits - or you will get infinite recursion
   */
  get resolvedRegionColumn() {
    return this.catalogItem.tableColumns.find(tableCol => {
      var _this$dimensionColumn;
      return tableCol.name === ((_this$dimensionColumn = this.dimensionColumns.find(dimCol => dimCol.type === "region")) === null || _this$dimensionColumn === void 0 ? void 0 : _this$dimensionColumn.name);
    });
  }

  /** If we only have a single region (or no regions)
   * We want to:
   * - disable the region column so we get a chart instead - see `get styles()`
   * - get region name for chart title (if single region) - see `get chartTitle()`
   **/
  get disableRegion() {
    var _this$resolvedRegionC, _this$resolvedRegionC2, _this$resolvedRegionC3;
    return !this.catalogItem.isLoading && ((_this$resolvedRegionC = this.resolvedRegionColumn) === null || _this$resolvedRegionC === void 0 ? void 0 : _this$resolvedRegionC.ready) && ((_this$resolvedRegionC2 = (_this$resolvedRegionC3 = this.resolvedRegionColumn) === null || _this$resolvedRegionC3 === void 0 ? void 0 : _this$resolvedRegionC3.valuesAsRegions.uniqueRegionIds.length) !== null && _this$resolvedRegionC2 !== void 0 ? _this$resolvedRegionC2 : 0) <= 1;
  }

  /** Get nice title to use for chart
   * If we have a region column with a single region, it will append the region name to the title
   */
  get chartTitle() {
    if (this.disableRegion) {
      var _this$resolvedRegionC4;
      const regionValues = (_this$resolvedRegionC4 = this.resolvedRegionColumn) === null || _this$resolvedRegionC4 === void 0 ? void 0 : _this$resolvedRegionC4.uniqueValues.values;
      if (regionValues && regionValues.length === 1) {
        var _this$getDimensionsWi2;
        // Get region dimension ID
        const regionDimensionId = (_this$getDimensionsWi2 = this.getDimensionsWithOverrideType("region")[0]) === null || _this$getDimensionsWi2 === void 0 ? void 0 : _this$getDimensionsWi2.id;
        // Lookup in sdmxDimensions to get codelist (this is needed because region dimensions which have more options than MAX_SELECTABLE_DIMENSION_OPTIONS will not return any dimension.options)
        const regionDimension = this.sdmxDimensions.find(dim => dim.id === regionDimensionId);
        if (regionDimension) {
          var _regionDimension$loca, _codelist$codes$find$2, _codelist$codes3;
          // Try to get human readable region name from codelist
          const codelist = this.getCodelistByUrn((_regionDimension$loca = regionDimension.localRepresentation) === null || _regionDimension$loca === void 0 ? void 0 : _regionDimension$loca.enumeration);
          const regionName = (_codelist$codes$find$2 = codelist === null || codelist === void 0 || (_codelist$codes3 = codelist.codes) === null || _codelist$codes3 === void 0 || (_codelist$codes3 = _codelist$codes3.find(c => c.id === regionValues[0])) === null || _codelist$codes3 === void 0 ? void 0 : _codelist$codes3.name) !== null && _codelist$codes$find$2 !== void 0 ? _codelist$codes$find$2 : regionValues[0];
          return "".concat(regionName, " - ").concat(this.unitMeasure);
        }
      }
    }
    return this.unitMeasure;
  }

  /**
   * Set TableStyleTraits for primary measure column:
   * - Legend title is set to `unitMeasure` to add context - eg "AUD (Quarterly)"
   * - Chart traits are set if this dataflow is time-series with no region-mapping:
   *   - `xAxisColumn` to time column name
   *   - `lines.name` set to `unitMeasure`
   *   - `lines.yAxisColumn` set to primary measure column
   * - `regionColumn` set to region dimension name (if one exists)
   */
  get styles() {
    if (this.primaryMeasureColumn) {
      var _this$resolvedRegionC5;
      return [createStratumInstance(TableStyleTraits, {
        id: this.primaryMeasureColumn.name,
        color: createStratumInstance(TableColorStyleTraits, {
          legend: createStratumInstance(LegendTraits, {
            title: this.unitMeasure
          }),
          /** Enable z-score filtering (see TableColorStyleTraits.zScoreFilter) */
          zScoreFilter: 4
        }),
        time: createStratumInstance(TableTimeStyleTraits, {
          timeColumn: this.timeColumns[0].name,
          spreadStartTime: true,
          spreadFinishTime: true
        }),
        // Add chart if there is a time column but no region column
        chart: this.timeColumns.length > 0 && (this.disableRegion || !this.resolvedRegionColumn) ? createStratumInstance(TableChartStyleTraits, {
          xAxisColumn: this.timeColumns[0].name,
          lines: [createStratumInstance(TableChartLineStyleTraits, {
            name: this.chartTitle,
            yAxisColumn: this.primaryMeasureColumn.name
          })]
        }) : undefined,
        regionColumn: this.disableRegion ? null : (_this$resolvedRegionC5 = this.resolvedRegionColumn) === null || _this$resolvedRegionC5 === void 0 ? void 0 : _this$resolvedRegionC5.name
      })];
    }
    return [];
  }

  /**
   * Set active table style to primary measure column
   */
  get activeStyle() {
    var _this$primaryMeasureC2;
    return (_this$primaryMeasureC2 = this.primaryMeasureColumn) === null || _this$primaryMeasureC2 === void 0 ? void 0 : _this$primaryMeasureC2.name;
  }

  /**
   * Set default time to last time of dataset
   */
  get initialTimeSource() {
    return "stop";
  }

  /**
   * Formats feature info table to add:
   * - Current time (if time-series)
   * - Selected region (if region-mapped)
   * - All dimension values
   * - Formatted primary measure (the actual value)
   * - Time-series chart
   */
  get featureInfoTemplate() {
    var _this$resolvedRegionC6, _this$timeColumns, _filterEnums, _ref5, _ref6, _this$unitMeasure, _this$primaryMeasureC3, _this$primaryMeasureC4, _this$primaryMeasureC5;
    const regionType = (_this$resolvedRegionC6 = this.resolvedRegionColumn) === null || _this$resolvedRegionC6 === void 0 ? void 0 : _this$resolvedRegionC6.regionType;
    if (!regionType) return;
    let template = '<table class="cesium-infoBox-defaultTable">';

    // Function to format row with title and value
    const row = (title, value) => "<tr><td style=\"vertical-align: middle\">".concat(title, "</td><td>").concat(value, "</td></tr>");

    // Get time dimension values
    template += (_this$timeColumns = this.timeColumns) === null || _this$timeColumns === void 0 ? void 0 : _this$timeColumns.map(col => {
      var _col$title;
      return row((_col$title = col.title) !== null && _col$title !== void 0 ? _col$title : "Time", "{{".concat(col.name, "}}"));
    }).join(", ");

    // Get region dimension values

    template += row(regionType === null || regionType === void 0 ? void 0 : regionType.description, "{{".concat(regionType === null || regionType === void 0 ? void 0 : regionType.nameProp, "}}"));

    // Get other dimension values
    template += (_filterEnums = filterEnums(this.catalogItem.sdmxSelectableDimensions)) === null || _filterEnums === void 0 ? void 0 : _filterEnums.filter(d => (d.name || d.id) && !d.disable && d.selectedId).map(d => {
      var _d$options, _selectedOption$name;
      const selectedOption = (_d$options = d.options) === null || _d$options === void 0 ? void 0 : _d$options.find(o => o.id === d.selectedId);
      return row(d.name || d.id, (_selectedOption$name = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) !== null && _selectedOption$name !== void 0 ? _selectedOption$name : d.selectedId);
    }).join("");
    const primaryMeasureName = (_ref5 = (_ref6 = (_this$unitMeasure = this.unitMeasure) !== null && _this$unitMeasure !== void 0 ? _this$unitMeasure : (_this$primaryMeasureC3 = this.primaryMeasureColumn) === null || _this$primaryMeasureC3 === void 0 ? void 0 : _this$primaryMeasureC3.title) !== null && _ref6 !== void 0 ? _ref6 : (_this$primaryMeasureC4 = this.primaryMeasureColumn) === null || _this$primaryMeasureC4 === void 0 ? void 0 : _this$primaryMeasureC4.name) !== null && _ref5 !== void 0 ? _ref5 : "Value";
    template += row("", "") + row(primaryMeasureName, "{{#terria.formatNumber}}{useGrouping: true}{{".concat((_this$primaryMeasureC5 = this.primaryMeasureColumn) === null || _this$primaryMeasureC5 === void 0 ? void 0 : _this$primaryMeasureC5.name, "}}{{/terria.formatNumber}}"));

    // Add timeSeries chart if more than one time observation
    if (this.catalogItem.discreteTimes && this.catalogItem.discreteTimes.length > 1) {
      var _this$primaryMeasureC6;
      const chartName = "".concat(this.catalogItem.name, ": {{").concat(regionType.nameProp, "}}");
      template += "</table>{{#terria.timeSeries.data}}<chart title=\"".concat(chartName, "\" x-column=\"{{terria.timeSeries.xName}}\" y-column=\"").concat((_this$primaryMeasureC6 = this.primaryMeasureColumn) === null || _this$primaryMeasureC6 === void 0 ? void 0 : _this$primaryMeasureC6.title, "\" >{{terria.timeSeries.data}}</chart>{{/terria.timeSeries.data}}");
    }
    return createStratumInstance(FeatureInfoTemplateTraits, {
      template
    });
  }

  // ------------- START SDMX STRUCTURE HELPER FUNCTIONS -------------
  getConceptScheme(id) {
    var _this$sdmxJsonDataflo1;
    if (!isDefined(id)) return;
    return (_this$sdmxJsonDataflo1 = this.sdmxJsonDataflow.conceptSchemes) === null || _this$sdmxJsonDataflo1 === void 0 ? void 0 : _this$sdmxJsonDataflo1.find(c => c.id === id);
  }
  getConceptByUrn(urn) {
    var _conceptUrn$descendan4, _resolvedConceptSchem;
    if (!urn) return;
    const conceptUrn = parseSdmxUrn(urn);
    const conceptSchemeId = conceptUrn === null || conceptUrn === void 0 ? void 0 : conceptUrn.resourceId;
    const conceptId = conceptUrn === null || conceptUrn === void 0 || (_conceptUrn$descendan4 = conceptUrn.descendantIds) === null || _conceptUrn$descendan4 === void 0 ? void 0 : _conceptUrn$descendan4[0];
    if (!isDefined(conceptId)) return;
    const resolvedConceptScheme = typeof conceptSchemeId === "string" ? this.getConceptScheme(conceptSchemeId) : conceptSchemeId;
    return resolvedConceptScheme === null || resolvedConceptScheme === void 0 || (_resolvedConceptSchem = resolvedConceptScheme.concepts) === null || _resolvedConceptSchem === void 0 ? void 0 : _resolvedConceptSchem.find(d => d.id === conceptId);
  }
  getCodelistByUrn(urn) {
    var _this$sdmxJsonDataflo10;
    if (!urn) return;
    const codelistUrn = parseSdmxUrn(urn);
    const id = codelistUrn === null || codelistUrn === void 0 ? void 0 : codelistUrn.resourceId;
    if (!isDefined(id)) return;
    return (_this$sdmxJsonDataflo10 = this.sdmxJsonDataflow.codelists) === null || _this$sdmxJsonDataflo10 === void 0 ? void 0 : _this$sdmxJsonDataflo10.find(c => c.id === id);
  }

  /**
   * Find modelOverrides with type 'region-type' to try to extract regionType from another dimension
   * For example, ABS have a regionType dimension which may have values (SA1, SA2, ...), which could be used to determine regionType
   */
  getDimensionsWithOverrideType(type) {
    var _this$catalogItem$mod3;
    return filterOutUndefined((_this$catalogItem$mod3 = this.catalogItem.modelOverrides) === null || _this$catalogItem$mod3 === void 0 ? void 0 : _this$catalogItem$mod3.filter(override => override.type === type && override.id).map(override => {
      var _this$catalogItem$dim;
      // Find dimension id with concept or codelist
      return (_this$catalogItem$dim = this.catalogItem.dimensions) === null || _this$catalogItem$dim === void 0 ? void 0 : _this$catalogItem$dim.find(d => {
        var _this$getDimensionWit;
        return d.id === ((_this$getDimensionWit = this.getDimensionWithConceptOrCodelist(override.id)) === null || _this$getDimensionWit === void 0 ? void 0 : _this$getDimensionWit.id);
      });
    }));
  }
  getDimensionWithConceptOrCodelist(id) {
    return this.sdmxDimensions.find(dim => {
      var _dim$localRepresentat5;
      return dim.conceptIdentity === id || ((_dim$localRepresentat5 = dim.localRepresentation) === null || _dim$localRepresentat5 === void 0 ? void 0 : _dim$localRepresentat5.enumeration) === id;
    });
  }
  getAttributionWithConceptOrCodelist(id) {
    return this.sdmxAttributes.find(attr => {
      var _attr$localRepresenta;
      return attr.conceptIdentity === id || ((_attr$localRepresenta = attr.localRepresentation) === null || _attr$localRepresenta === void 0 ? void 0 : _attr$localRepresenta.enumeration) === id;
    });
  }
}, _defineProperty(_SdmxJsonDataflowStratum, "stratumName", "sdmxJsonDataflow"), _SdmxJsonDataflowStratum), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "metadataUrls", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "metadataUrls"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shortReportSections", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReportSections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modelOverrides", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "modelOverrides"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unitMeasure", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unitMeasure"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "primaryMeasureColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "primaryMeasureColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dimensionColumns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dimensionColumns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeColumns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeColumns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "attributeColumns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "attributeColumns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "columns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "columns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resolvedRegionColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resolvedRegionColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableRegion", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableRegion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "chartTitle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "chartTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "styles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "styles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initialTimeSource", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "initialTimeSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "featureInfoTemplate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "featureInfoTemplate"), _class.prototype), _class);
StratumOrder.addLoadStratum(SdmxJsonDataflowStratum.stratumName);